"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNil = void 0;
function isNil(value) {
    return value === undefined || value === null;
}
exports.isNil = isNil;
